//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'

//#endregion

import { Enums } from '../../../models/common/enums'
import { IUserSession } from '../../../helpers/user-session'

import { EventsNames } from '../../../helpers/events-names'
import { UserModel, FormValuesModel } from '../../api/api.models'
import { i18n } from '../../common/i18n/common.i18n'
import { CommonHelper } from '../../../helpers/common-helper'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { GridOptions, GridTypes } from '../grid/grid.controller'

import { OpOperator } from '../../../models/core/op-operator'

import { ActiveDistributorInfo } from '../../../models/local/active-distributor-info'
import { ActiveDistributorsInfo } from '../../../models/local/active-distributors-info'

import { SYSTEM_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SystemService } from '../../..//services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { ConfigHelper } from '../../../helpers/config-helper';
import { TemplateHelper, LocalizationHelper, TypeHelper } from '../../../helpers'
import { IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupOptions } from '../confirmation-popup2'

//#region Asset Imports

import './user-menu.scss'
import * as TEMPLATE from './user-menu.tpl.html'

//#endregion

interface UserMenuScope extends ng.IScope {
    user: UserModel
    loggedOperator: OpOperator
    options: any
    openUserDetails(): void
    openChangePassword(): void
    distributors: ActiveDistributorsInfo
    isDisabledSubmit: boolean
    logoutIcon: string
    menuPopoverOptions: DevExpress.ui.dxPopoverOptions
    menuPopover: DevExpress.ui.dxPopover

    showNoPermission: boolean
    userDetailsPopupId: number
    showUserDetails: boolean
    canChangePassword: boolean

    myAccountButtonOptions: DevExpress.ui.dxButtonOptions
    signOutButtonOptions: DevExpress.ui.dxButtonOptions
    submitButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonOptions: DevExpress.ui.dxButtonOptions
    changePasswordButtonOptions: DevExpress.ui.dxButtonOptions
    resetUserSettingsButtonOptions: DevExpress.ui.dxButtonOptions
    resetUserSettingsConfirmationPopupOptions: IMRConfirmationPopupOptions

    gridOptions: GridOptions
    loading: boolean

    distributorsLoaded: boolean

    logout(): void
}

export class UserMenuDirective implements ng.IDirective {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.Common.UserMenu.Directive] - %s' }

    // Consts End

    private grid: DevExpress.ui.dxDataGrid
    private resetUserSettingsConfirmationPopup: IIMRConfirmationPopup

    constructor() {

    }

    restrict = 'E'
    scope = {
        user: '=',
        options: '=',
        distributors: '=activeDistributors'
    }
    controller = [$SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'localDictionary', SYSTEM_SERVICE_NAME, USER_SESSION_SERVICE_NAME, (
        $scope: UserMenuScope,
        $timeout: ng.ITimeoutService,
        localDictionary: LocalDictionaryFactory,
        systemService: SystemService,
        userSession: IUserSession
    ) => {

        $scope.isDisabledSubmit = true


        // Auth mode
        const currentAuthMode: Enums.AuthenticationMode = ConfigHelper.getValue<Enums.AuthenticationMode>(Enums.SimaxConfigSection.Authentication, ConfigHelper.Key.Mode)
        const canChangePassword: boolean = !_.contains([Enums.AuthenticationMode.Domain, Enums.AuthenticationMode.SimpleDomain], currentAuthMode)
        $scope.canChangePassword = canChangePassword

        if (!canChangePassword) {
            console.log(UserMenuDirective.LOG_STRING, "Auth mode is Domain or Simple Domain. Password change is locked.")
        }


        $scope.logoutIcon = window['config']['ICONS']['LOGOUT']
        $scope.loggedOperator = userSession.getLoggedOperator()

        $scope.userDetailsPopupId = $scope.$id

        $scope.openUserDetails = () => {
            systemService.openDetails({
                moduleName: Enums.SimaxModuleName.Operator,
                referenceObjectId: $scope.loggedOperator.idOperator
            })

            $scope.options.popoverVisible = false
        }

        $scope.openChangePassword = () => {
            $scope.$root.$broadcast(EventsNames.OPEN_PASSWORD_CHANGE_POPUP, $scope.loggedOperator.idOperator, [{
                id: $scope.loggedOperator.idOperator,
                name: $scope.loggedOperator.toString()
            }])

            $scope.options.popoverVisible = false
        }

        var submitDistributors = () => {
            var newIdActiveDistributors: number[] = []
            $scope.loading = true
            var selectedData: ActiveDistributorInfo[] = this.grid.getSelectedRowsData()
            selectedData.forEach(dist => {
                newIdActiveDistributors.push(dist.distributor.idDistributor)
            })

            var model = new FormValuesModel()
            model.values = newIdActiveDistributors

            var currentIdActiveDistributors: number[] = userSession.getDataProvider().Distributor.getIdActiveDistributorsLocal()
            if (!currentIdActiveDistributors)
                currentIdActiveDistributors = []
            if (currentIdActiveDistributors.length != newIdActiveDistributors.length || !(_.isEqual(currentIdActiveDistributors, newIdActiveDistributors))) {
                userSession.getDataProvider().Distributor.setIdActiveDistributorsLocal(newIdActiveDistributors)

                var parameters = []
                parameters.push(Enums.DBCollectorProperties.Relogin)
                parameters.push([newIdActiveDistributors])

                userSession.getDataProvider().Session.initDBCollectorProperties(parameters).then(result => {
                    userSession.getDataProvider().Distributor.getActiveDistributorsInfo(selectedData.length > 1 ? selectedData[0].distributor : null).then(activeDistributorInfo => {
                        $scope.distributors = activeDistributorInfo

                        $scope.isDisabledSubmit = true
                        //DO USUNIECIA!!!
                        localDictionary.refreshDictionaries(true).then(result => {
                            CommonHelper.openInfoPopup(i18n('Popup', 'ChangeAllowedDistributorsSuccess'))
                            $scope.$root.$broadcast(EventsNames.CHANGED_ALLOWED_DISTRIBUTORS, $scope.distributors, newIdActiveDistributors)
                            $scope.loading = false
                            this.grid.endCustomLoading()
                        })
                    })
                }).fail(rej => {
                    CommonHelper.openInfoPopup(i18n('Popup', 'ChangeAllowedDistributorsError'), 'error', 5000)
                    $scope.loading = false
                    this.grid.endCustomLoading()
                })
            }
            else {
                $scope.loading = false
                this.grid.endCustomLoading()
            }
        }

        $scope.menuPopoverOptions = {
            width: 400,
            height: 500,
            onInitialized: (e) => {
                $scope.menuPopover = e.component
            },
            target: '.menu-button',
            bindingOptions: {
                visible: 'options.popoverVisible'
            },
            onHiding: () => {
                $scope.options.popoverVisible = false
            }
        }

        $scope.myAccountButtonOptions = {
            text: i18n('Common', 'MyAccount'),
            onClick: $scope.openUserDetails,
            height: 36
        }

        $scope.signOutButtonOptions = {
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SignOut), ConfigHelper.Icon.LOGOUT, userSession),
            height: 36
        }

        $scope.changePasswordButtonOptions = {
            hint: i18n('Popup', 'ChangePassword'),
            template: TemplateHelper.getIcon(ConfigHelper.Icon.PASSWORD, userSession),
            onClick: $scope.openChangePassword,
            height: 36
        }

        $scope.logout = () => {
            CommonHelper.logoutFromApp($scope, userSession)
        }

        var activeDistributorsDefer: ng.IDeferred<ActiveDistributorInfo[]> = $scope.$root['activeDistributorsDefer']
        activeDistributorsDefer.promise.then(allDistributors => {
            $scope.distributorsLoaded = true
            var ds = new DataSource(allDistributors)
            $scope.gridOptions = <GridOptions>{
                name: null,
                idReferenceType: Enums.ReferenceType.None,
                type: GridTypes.NO_SEARCH_BAR_SMALL_SINGLE_PAGE,
                buttonsOptions: {
                    enabled: false
                },
                columns: [
                    {
                        dataField: 'distributor.name',
                        caption: i18n('Common', 'Distributor'),
                        allowEditing: false,
                        dataType: 'string'
                    }
                ],
                scrolling: {
                    mode: 'virtual'
                },
                selection: {
                    mode: 'multiple',
                    showCheckBoxesMode: 'always'
                },
                dataSource: ds,
                onInitialized: e => {
                    this.grid = e.component
                    this.grid.selectRows(allDistributors.filter(d => d.isActive), false)
                },
                onToolbarPreparing: e => {//ChangegAllowedDistributors
                    var toolbarItems = e.toolbarOptions.items
                    _.each(toolbarItems, item => {
                        if (item['name'] === 'saveButton' || item['name'] === 'revertButton') {
                            item['options'].visible = false
                        }
                    })
                    toolbarItems.unshift({
                        widget: 'dxButton',
                        options: {
                            onClick: (el) => {
                                this.grid.beginCustomLoading(i18n("Grid", "Loading"))
                                this.grid.refresh()
                                $timeout(() => {//ChangegAllowedDistributors
                                    submitDistributors()
                                })
                            },
                            hint: i18n("Common", "CustomDistView"),
                            icon: 'fa fa-share-alt',
                        },
                        location: 'after'
                    })
                }
            }
        })

        //close popover on ESC press  
        $scope.$on(EventsNames.ESC_KEY_PRESS, () => {
            if ($scope.menuPopoverOptions) {
                $timeout(() => {
                    $scope.options.popoverVisible = false
                })
            }
        })

        const onResetUserSettingsClick = () => {
            if (this.resetUserSettingsConfirmationPopup != null) {
                this.resetUserSettingsConfirmationPopup.show()
            }
        }

        $scope.resetUserSettingsButtonOptions = {
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ResetSettings),
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE_SWEEP, userSession),
            onClick: onResetUserSettingsClick,
            height: 36
        }

        // #region Confirmation Popup

        const onResetUserSettingsConfirm = () => {
            userSession.getDataProvider().Operator.resetOperatorSessions(userSession.getDataProvider().Operator.getLoggedOperatorLocal().idOperator)
            userSession.getDataProvider().LocalStorage.removeLoggedOperatorSettings(-1)
            userSession.getDataProvider().Session.logout()
        }

        const initializeConfirmationPopup = (): JQueryPromise<any> => {
            $scope.resetUserSettingsConfirmationPopupOptions = {
                content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ResetSettingsConfirmationText),
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                    this.resetUserSettingsConfirmationPopup = e.component
                },
                onConfirmed: () => {
                    onResetUserSettingsConfirm()
                }
            }

            return TypeHelper.onInitializedAll($scope.resetUserSettingsConfirmationPopupOptions)
        }

        initializeConfirmationPopup()

        //#endregion


    }]
    template = TEMPLATE
    replace = true
}